var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields",class:_vm.classes},_vm._l((_vm.childrenFieldModels),function(field){return _c('field',{key:field.id,ref:"fields",refInFor:true,attrs:{"field":field,"field-models":_vm.fieldModels,"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }